import React, { useEffect } from 'react'
import { useContext } from 'react'
import { AuthContext } from '../Auth/AuthProvider'
import { NotificationContext } from 'src/context/NotificationContext'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import { Role, useGetOrganizationQuery } from 'src/gql/graphql'
import { toast } from 'react-toastify'
import { PlanOverlayModal } from './PlanOverlayModal'

export const PlanWorkspaceWrapper = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const organizationId = localStorage.getItem('organizationId') || ''
  const { userInfo } = useContext(AuthContext)
  const { t } = useTranslation()
  const { isDisabledWorkspace, isExceedingPlanWorkspace } =
    useContext(NotificationContext)
  const { data: organizationData } = useGetOrganizationQuery({
    variables: { id: organizationId },
    onError: () => {
      toast.error(
        t('notification.errorLoading', {
          name: t('common.word.workspace'),
        }),
      )
    },
  })

  const calculateDayGap = (gracePeriodEnd: string | Date): number => {
    if (!gracePeriodEnd) return 0

    const endDate = new Date(gracePeriodEnd)
    const today = new Date()

    // Reset time part to ensure we only compare dates
    endDate.setHours(0, 0, 0, 0)
    today.setHours(0, 0, 0, 0)

    // Calculate difference in milliseconds and convert to days
    const diffTime = endDate.getTime() - today.getTime()
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

    return diffDays
  }

  const remainingDays = calculateDayGap(
    organizationData?.organization?.stripeUpgradePrompt?.gracePeriodEnd || '',
  )

  const [closed, setClosed] = useState(false)

  const currentRole = userInfo?.employeeDetails?.role?.name
  const doesInlucdeITRole = userInfo?.roles?.some(
    (role) => role?.name === Role.It,
  )
  const isAdmin = currentRole === Role.It || !!doesInlucdeITRole

  const messages = {
    isDisabledWorkspace: isAdmin
      ? t('resoure.disabledWorkspace.upgradePlanSuggestion')
      : t('resoure.disabledWorkspace.contactAdmin'),
    isExceedingPlanWorkspace: isAdmin
      ? t('resoure.exceedingPlanWorkspace.upgradePlanSuggestion', {
          remaining_days: remainingDays,
        })
      : t('resoure.exceedingPlanWorkspace.contactAdmin', {
          remaining_days: remainingDays,
        }),
  }

  useEffect(() => {
    if (isExceedingPlanWorkspace || isDisabledWorkspace) {
      setClosed(false)
    }
  }, [isExceedingPlanWorkspace, isDisabledWorkspace])

  if ((isExceedingPlanWorkspace || isDisabledWorkspace) && !closed) {
    return (
      <PlanOverlayModal
        isAdmin={isAdmin}
        setClosed={setClosed}
        message={
          messages[
            isDisabledWorkspace
              ? 'isDisabledWorkspace'
              : 'isExceedingPlanWorkspace'
          ]
        }
      >
        {children}
      </PlanOverlayModal>
    )
  }
  return <>{children}</>
}
